import { createContext, useContext } from 'react'

import { PerformanceV2FeaturesAvailability } from 'modules/performance_v2/lib/getModuleFeatures'

export interface PerformanceV2ModuleContextProps {
  featuresAvailability: PerformanceV2FeaturesAvailability
}

export const PerformanceV2ModuleContext =
  createContext<PerformanceV2ModuleContextProps | null>(null)

export const usePerformanceV2ModuleContext = () => {
  const context = useContext(PerformanceV2ModuleContext)
  if (!context) {
    throw new Error('PerformanceV2ModuleContext must be within its provider')
  }
  return context
}
